import { formatPrice } from '../../shared/helpers';

import type { TierPlan } from '@avalara/types/index';
import type { BuyFlowState } from '@avalara/types/reducer-states';

export const getTierCost = (tier: TierPlan | null): number => {
  if (!tier) return 0;

  return tier.recurringPrice + (tier.waived ? 0 : tier.activationPrice);
};

export const getTotalCost = (state: BuyFlowState): number => {
  const tax = state.salestax || 0;
  return tax + getTierCost(state.selectedTier);
};

export const getCartTotalCost = (state: BuyFlowState): string => formatPrice(getTotalCost(state));
